import styled from 'styled-components';

export const ContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 428px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
